export default [
  {
    name: 'discovery.index',
    path: '/discovery',
    component: () => import('@/views/Discovery'),
    children: [
      {
        path: 'list/manage/:listId?',
        name: 'discovery.index.lists.manage',
        component: () => import('@/components/lists/ModalManageList'),
        meta: {
          backRouteName: 'discovery.index'
        }
      },
      {
        path: 'list/details/:listId',
        name: 'discovery.index.lists.details',
        component: () => import('@/components/lists/ModalListDetails'),
        meta: {
          backRouteName: 'discovery.index'
        },
        children: [
          {
            path: 'manage',
            name: 'discovery.index.lists.details.lists.manage',
            component: () => import('@/components/lists/ModalManageList'),
            meta: {
              backRouteName: 'discovery.index.lists.details'
            }
          }
        ]
      }
    ]
  }
]
